/* ============================================================
   CeilingSAM LV Permanent Overrides - JS
   Loaded from layout/theme.liquid (NOT from any section file).
   This file is NEVER touched by the Shopify section editor,
   so logic placed here survives section-file regressions.

   Owners:
     1. Hero H1 rewrite for the LV landing page.
        Original H1 (from frozen sections/cs-lp-lasvegas.liquid):
          <h1>Garage Storage <em>Installed</em> by Las Vegas Pros</h1>
        Rewritten to a three-line layout via innerHTML:
          'Garage Storage' / 'Professionally Installed' (red) / 'In Las Vegas'
        The red span uses class .cs-h1-red, colored by cs-lv-permanent.css.

     2. Gabe form-section contact link inline-color STRIPPER.
        Earlier versions of this file set inline color:#fff !important
        via setProperty on each link to make white permanent. That broke
        the CSS :hover state because inline !important beats stylesheet
        :hover !important. Now the CSS in cs-lv-permanent.css owns both
        the white default and red hover via :hover pseudo-class with high
        specificity + !important. This JS is defensive only: it STRIPS
        any inline color set by any other code (frozen file, btn-colors
        patch, or future patches) so the CSS rules can take effect.
        The MutationObserver re-strips if inline color is set later.
        Removing inline color does not re-trigger the observer infinitely
        because the if(a.style.color) guard returns false the second time.

     3. LV form-section H2 PERMANENT REWRITE.
        Selector: '.lv-form-section .lv-gabe-col h2' (the BIG white H2 in
        the left column of the navy form section, NOT '.lv-gabe-col__title'
        which is the small mono 'Las Vegas Storage Expert' tag).
        Catches both the frozen source text ('Book your free in-home
        estimate with Gabe.') and the 'Request your...' variant that
        other patches inject, and rewrites both to:
          'Free in-home estimate with Gabe.'
        cs-lv-gabe-namecard.liquid has its own version of this rewrite,
        but it lacks a MutationObserver so it loses races against the
        theme editor live preview and other late-rendering code.
        Idempotent: textContent equality check returns early when the
        H2 already says the target, so MutationObserver re-fires from
        our own set don't loop.
        MutationObserver on .lv-form-section catches any runtime
        re-renders (theme editor, cs-lv-gabe-namecard re-runs, etc.)
        and re-rewrites instantly.
        TIGHT SCOPE: does NOT touch '.lv-form h3' (which holds
        'Request your free estimate' on the right column and must
        stay unchanged), and does NOT touch any other h2 on the page.

     4. LV "4'X8' Storage Elevators Bundle" name + dropdown label rewrite.
        The frozen sections/cs-lp-lasvegas.liquid renders the FIRST bundle
        card with:
          name:    "2 Storage Elevators™ Bundle"
          options: "2x Standard 400 lb (8'–11') — $3,998"
                   "2x Max 400 lb (11.5'–14') — $4,198"
                   "2x Pro 700 lb (8'–11') — $4,598"
                   "2x Pro Max 700 lb (11.5'–14') — $4,798"
        Rewritten at runtime to:
          name:    "2 4'X8' Storage Elevators Bundle"
          options: "2x Standard 400 lb (8-11 ceilings): $3,998"
                   "2x Max 400 lb (11.5-14 ceilings): $4,198"
                   "2x Pro 700 lb (8-11 ceilings): $4,598"
                   "2x Pro Max 700 lb (11.5-14 ceilings): $4,798"
        Em dash before price is replaced with a colon to follow Dylan's
        standing no-em-dash content rule. The en/em dash inside the
        parentheses is dropped in favor of a plain hyphen plus the word
        "ceilings" so the range reads as a ceiling-height clarifier
        instead of a cryptic foot range.
        Bundle is matched by name text (/^2\s+(?:4'X8'\s+)?Storage\s+Elevators/i)
        so the SECOND bundle card ("Complete Garage Bundles" multi-product)
        is untouched. Options are matched by /^\s*2x\s+(?:Standard|Max|Pro)\b/i
        which only fires on the four "Standard / Max / Pro / Pro Max"
        variants of THIS bundle — the second card's options start with
        "2x Wall Shelf", "2x Tote Slide", "2x 4'×8' Heavy-Duty Racks",
        "2x Tote Slide Pros + 2x Racks" and don't match.
        Idempotent: name skipped when textContent already equals
        TARGET_NAME; options skipped when text already contains "ceilings".
        MutationObserver on .lv-bundle-grid catches theme-editor live
        preview re-renders.

     5. LV estimate form -> Klaviyo LIVE list "Gabes Vegas Leads" (Xhi48X).
        The frozen LV section's csLVSubmit() only POSTs to /contact. This
        hook adds a parallel fire-and-forget Klaviyo client subscription
        so LV website leads land on the SAME live list Gabe's Meta leads
        use, firing the live "INTERNAL - Vegas Meta Lead Alert" flow.
        Mirrors csLVSubmit validation (first name + phone + email) so it
        only fires when the visible form actually submits. custom_source
        and Lead Source = 'LV Landing Page' so website leads are
        distinguishable from Meta leads inside the list and in segments.

     6. NW contact form -> Klaviyo LIVE list "Contact Us Form" (VMnr9x).
        Same pattern for the frozen nationwide section's csNWSubmit()
        (validation: first name + email). Fires the live "Welcome Series:
        New Contact Us Form" flow. custom_source and Lead Source =
        'Nationwide Landing Page'.
   ============================================================ */

/* ---- HERO H1 REWRITE ---- */
(function(){
  function rewriteHeroH1(){
    var h1=document.querySelector('#cs-cat .lv-hero h1');
    if(!h1) return;
    if(h1.querySelector('.cs-h1-red')) return;
    var current=h1.textContent.replace(/\s+/g,' ').trim();
    if(/garage\s+storage\s+installed\s+by\s+las\s+vegas\s+pros/i.test(current)){
      h1.innerHTML='Garage Storage <br><span class="cs-h1-red">Professionally Installed</span> <br>In Las Vegas';
    }
  }
  function startHeroH1Observer(){
    var containers=document.querySelectorAll('#cs-cat .lv-hero');
    containers.forEach(function(c){
      if(c.getAttribute('data-cs-h1-obs')==='1') return;
      c.setAttribute('data-cs-h1-obs','1');
      var obs=new MutationObserver(function(){
        rewriteHeroH1();
      });
      obs.observe(c,{childList:true,characterData:true,subtree:true});
    });
  }
  function run(){
    rewriteHeroH1();
    startHeroH1Observer();
  }
  [80,250,700,1500,3000].forEach(function(t){setTimeout(run,t);});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();

/* ---- GABE CONTACT LINKS: strip inline color so CSS rules can apply ----
   CSS in cs-lv-permanent.css handles white default + red hover. This JS
   is defensive only - it removes any inline color set by other code so
   the CSS rules (including :hover) can take effect. Does NOT set color,
   does NOT attach mouseenter/mouseleave listeners (which would fight
   against the CSS :hover state and produce no visible hover effect). */
(function(){
  function stripGabeContactInlineColor(){
    var root=document.getElementById('cs-cat');
    if(!root) return;
    var links=root.querySelectorAll('.lv-form-section .lv-gabe-col__contact a, .lv-gabe-col__card .lv-gabe-col__contact a');
    links.forEach(function(a){
      if(a.style && a.style.color){
        a.style.removeProperty('color');
      }
    });
  }
  function startGabeContactObserver(){
    if(typeof MutationObserver==='undefined') return;
    var root=document.getElementById('cs-cat');
    if(!root) return;
    var containers=root.querySelectorAll('.lv-form-section .lv-gabe-col__contact, .lv-gabe-col__card .lv-gabe-col__contact');
    containers.forEach(function(c){
      if(c.getAttribute('data-cs-gabe-contact-obs')==='1') return;
      c.setAttribute('data-cs-gabe-contact-obs','1');
      var obs=new MutationObserver(function(){stripGabeContactInlineColor();});
      obs.observe(c,{attributes:true,attributeFilter:['style'],subtree:true,childList:true});
    });
  }
  function run(){stripGabeContactInlineColor();startGabeContactObserver();}
  [80,250,700,1500,3000].forEach(function(t){setTimeout(run,t);});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();

/* ---- LV ESTIMATE H2 PERMANENT REWRITE ----
   ".lv-form-section .lv-gabe-col h2" => "Free in-home estimate with Gabe."
   Tight scope so nothing else on the page is touched. Idempotent via
   textContent equality check (so MutationObserver feedback from our own
   set is a no-op). Observer makes this immune to late re-renders. */
(function(){
  var TARGET_TEXT='Free in-home estimate with Gabe.';
  function rewriteEstimateH2(){
    var root=document.getElementById('cs-cat');
    if(!root) return;
    var h2s=root.querySelectorAll('.lv-form-section .lv-gabe-col h2');
    h2s.forEach(function(h){
      var txt=(h.textContent||'').replace(/\s+/g,' ').trim();
      if(txt===TARGET_TEXT) return;
      if(/in.?home\s+estimate\s+with\s+gabe/i.test(txt)){
        h.textContent=TARGET_TEXT;
      }
    });
  }
  function startEstimateH2Observer(){
    if(typeof MutationObserver==='undefined') return;
    var root=document.getElementById('cs-cat');
    if(!root) return;
    var containers=root.querySelectorAll('.lv-form-section');
    containers.forEach(function(c){
      if(c.getAttribute('data-cs-estimate-h2-obs')==='1') return;
      c.setAttribute('data-cs-estimate-h2-obs','1');
      var obs=new MutationObserver(function(){rewriteEstimateH2();});
      obs.observe(c,{childList:true,characterData:true,subtree:true});
    });
  }
  function run(){rewriteEstimateH2();startEstimateH2Observer();}
  [80,250,700,1500,3000].forEach(function(t){setTimeout(run,t);});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();

/* ---- LV 4'X8' BUNDLE NAME + DROPDOWN LABEL REWRITE ----
   Bundle name: "2 Storage Elevators™ Bundle" => "2 4'X8' Storage Elevators Bundle"
   Dropdown options (Standard / Max / Pro / Pro Max variants of first bundle):
     "2x Standard 400 lb (8'–11') — $3,998"  =>  "2x Standard 400 lb (8-11 ceilings): $3,998"
     "2x Max 400 lb (11.5'–14') — $4,198"    =>  "2x Max 400 lb (11.5-14 ceilings): $4,198"
     "2x Pro 700 lb (8'–11') — $4,598"       =>  "2x Pro 700 lb (8-11 ceilings): $4,598"
     "2x Pro Max 700 lb (11.5'–14') — $4,798" => "2x Pro Max 700 lb (11.5-14 ceilings): $4,798"
   Em dash before price replaced with colon (no-em-dash rule). En/em dash
   inside parens dropped for plain hyphen + "ceilings" suffix for clarity.
   Second bundle card "Complete Garage Bundles" untouched (name doesn't
   match BUNDLE_NAME_PATTERN; options don't start with 2x Standard/Max/Pro). */
(function(){
  var TARGET_NAME='2 4\'X8\' Storage Elevators Bundle';
  var BUNDLE_NAME_PATTERN=/^\s*2\s+(?:4['\u2019]?\s*[xX\u00d7]\s*8['\u2019]?\s+)?Storage\s+Elevators/i;
  var OPT_PATTERN=/^\s*2x\s+(?:Standard|Max|Pro)\b/i;

  function rewriteBundle(){
    var root=document.getElementById('cs-cat');
    if(!root) return;
    // Bundle name rewrite (idempotent via equality check)
    var names=root.querySelectorAll('.lv-bundle__name');
    names.forEach(function(el){
      var txt=(el.textContent||'').replace(/\s+/g,' ').trim();
      if(txt===TARGET_NAME) return;
      if(!BUNDLE_NAME_PATTERN.test(txt)) return;
      el.textContent=TARGET_NAME;
    });
    // Dropdown option labels (idempotent via "ceilings" presence check)
    var opts=root.querySelectorAll('select.lv-bundle__select option');
    opts.forEach(function(opt){
      var t=opt.textContent||'';
      if(!OPT_PATTERN.test(t)) return;
      if(/\bceilings\b/i.test(t)) return;
      var nt=t
        .replace(/\(8['\u2019]?\s*[-\u2013\u2014]\s*11['\u2019]?\)/g,'(8-11 ceilings)')
        .replace(/\(11\.5['\u2019]?\s*[-\u2013\u2014]\s*14['\u2019]?\)/g,'(11.5-14 ceilings)')
        .replace(/\s+[\u2014\u2013]\s+(\$)/g,': $1');
      if(nt!==t) opt.textContent=nt;
    });
  }
  function startBundleObserver(){
    if(typeof MutationObserver==='undefined') return;
    var root=document.getElementById('cs-cat');
    if(!root) return;
    var grids=root.querySelectorAll('.lv-bundle-grid');
    grids.forEach(function(g){
      if(g.getAttribute('data-cs-bundle48-obs')==='1') return;
      g.setAttribute('data-cs-bundle48-obs','1');
      var obs=new MutationObserver(function(){rewriteBundle();});
      obs.observe(g,{childList:true,characterData:true,subtree:true});
    });
  }
  function run(){rewriteBundle();startBundleObserver();}
  [80,250,700,1500,3000].forEach(function(t){setTimeout(run,t);});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();

/* ---- LANDING PAGE FORMS -> KLAVIYO LIVE LISTS (owners 5 + 6) ----
   Frozen sections cs-lp-lasvegas.liquid and cs-lp-nationwide.liquid POST
   only to /contact. These hooks add a parallel fire-and-forget Klaviyo
   client subscription so leads land on the SAME live lists the current
   website delivers to, without touching the frozen files:
     LV estimate form  -> Gabes Vegas Leads (Xhi48X)
     NW contact form   -> Contact Us Form  (VMnr9x)
   Each hook mirrors the frozen submit handler's own validation so the
   Klaviyo call only fires when the visible form actually submits. The
   original /contact email flow is completely untouched. Idempotent via
   data-kl-hooked flag; retry timers cover late-rendered sections. */
(function(){
  function klSubscribe(listId, source, email, first, last, props){
    try{
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Y9BR3q',{
        method:'POST',
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:source,profile:{data:{type:'profile',attributes:{email:email,first_name:first,last_name:last,properties:props}}}},relationships:{list:{data:{type:'list',id:listId}}}}})
      }).catch(function(){});
    }catch(e){}
  }
  function v(sel){var el=document.querySelector(sel);return el?(el.value||'').trim():'';}
  function hookLV(){
    var btn=document.querySelector('#cs-cat .lv-form .lv-submit');
    if(!btn||btn.getAttribute('data-kl-hooked')==='1')return;
    btn.setAttribute('data-kl-hooked','1');
    btn.addEventListener('click',function(){
      var first=v('#cs-cat .lv-form [name=first_name]');
      var last=v('#cs-cat .lv-form [name=last_name]');
      var phone=v('#cs-cat .lv-form [name=phone]');
      var email=v('#cs-cat .lv-form [name=email]');
      if(!first||!phone||!email)return;
      klSubscribe('Xhi48X','LV Landing Page',email,first,last,{
        'Phone Number':phone,
        'Garage Size':v('#cs-cat .lv-form [name=garage_size]'),
        'Interest':v('#cs-cat .lv-form [name=interest]'),
        'Notes':v('#cs-cat .lv-form [name=notes]'),
        'Lead Source':'LV Landing Page'
      });
    });
  }
  function hookNW(){
    var btn=document.querySelector('#cs-cat .nw-lead__form .nw-submit');
    if(!btn||btn.getAttribute('data-kl-hooked')==='1')return;
    btn.setAttribute('data-kl-hooked','1');
    btn.addEventListener('click',function(){
      var first=v('#cs-cat .nw-lead__form [name=nw_first]');
      var last=v('#cs-cat .nw-lead__form [name=nw_last]');
      var email=v('#cs-cat .nw-lead__form [name=nw_email]');
      var phone=v('#cs-cat .nw-lead__form [name=nw_phone]');
      if(!first||!email)return;
      klSubscribe('VMnr9x','Nationwide Landing Page',email,first,last,{
        'Phone Number':phone,
        'Interest':v('#cs-cat .nw-lead__form [name=nw_interest]'),
        'Message':v('#cs-cat .nw-lead__form [name=nw_notes]'),
        'Lead Source':'Nationwide Landing Page'
      });
    });
  }
  function run(){hookLV();hookNW();}
  [80,250,700,1500,3000].forEach(function(t){setTimeout(run,t);});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();
